import React, {useState} from "react";
import Select from "react-select";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getProductsFilter} from "../_requests";
import Loading from "../../helpers/Loading";

export default function ProductListFilter({filter, _onProductsFilterChange}) {
    const allOption = [{value: 0, label: "All"}]

    const [ queryFilterChanged, setQueryFilterChanged ] = useState(false);
    const [ queryFilter, setQueryFilter ] = useState(filter);
    const _onSurfaceChange = (surface) => {
        let temp = queryFilter;
        temp.collection = [];
        temp.category = [];
        temp.type = [surface];
        setQueryFilter(temp);
        setQueryFilterChanged(queryFilterChanged ? false : true);
    };
    const _onCategoryChange = (category) => {
        let temp = queryFilter;
        temp.collection = [];
        category > 0 ? temp.category = [category] : temp.category = [];
        setQueryFilter(temp);
        setQueryFilterChanged(queryFilterChanged ? false : true);
    };
    const _onCollectionChange = (collection) => {
        let temp = queryFilter;
        collection > 0 ? temp.collection = [collection] : temp.collection = [];
        if(temp.category[0] === undefined) temp.category = [filterQuery.data.active.category]
        setQueryFilter(temp);
        //setQueryFilterChanged(queryFilterChanged ? false : true);
    };
    const _onBrandChange = (brand) => {
        let temp = queryFilter;
        brand > 0 ? temp.brand = [brand] : temp.brand = [];
        setQueryFilter(temp);
        setQueryFilterChanged(queryFilterChanged ? false : true);
    };

    const _onFilterSubmit = () => {
        let temp = queryFilter;
        temp.active = 0;
        _onProductsFilterChange(temp);
    };
    const _onFilterReset = () => {
        let temp = queryFilter;
        temp.active = 0;
        temp.brand = [];
        temp.collection = [];
        temp.category = [];
        temp.surface = [1];
        _onProductsFilterChange(temp);
    };

    const filterQuery =
        useQuery({
            queryKey: ['filter', queryFilter],
            queryFn: () => getProductsFilter(queryFilter),
            placeholderData: keepPreviousData,
            staleTime: 1 * 60 * 1000,
            cacheTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false
        })

    return <>
        <div className="card-body pt-7 scroll-y">
            {
                filterQuery.isPending || filterQuery.isFetching ? (
                    <Loading />
                ) : filterQuery.isError ? (
                    <p className="d-flex justify-content-center align-items-center text-center h-100">Error: {error.message}</p>
                ) : filterQuery.data && ([
                    <div key={1} className="mb-10">
                        <label className="form-label fw-semibold">Surface:</label>
                        <Select
                            name="type"
                            className='react-select-styled react-select-solid react-select-sm'
                            classNamePrefix='react-select'
                            options={filterQuery.data.filter.type}
                            placeholder='Select a surface'
                            defaultValue = {
                                filterQuery.data.filter.type.filter(option => option.value == filterQuery.data.active.type)
                            }
                            onChange={(assignedType) =>
                                _onSurfaceChange(assignedType.value)
                            }
                        />
                    </div>,
                    filterQuery.data.filter.category != undefined && <div key={2} className="mb-10">
                        <label className="form-label fw-semibold">Category:</label>
                        <Select
                            name="category"
                            className='react-select-styled react-select-solid react-select-sm'
                            classNamePrefix='react-select'
                            options={allOption.concat(filterQuery.data.filter.category)}
                            placeholder='All'
                            defaultValue = {
                                filterQuery.data.filter.category.filter(option => option.value == filterQuery.data.active.category) || 0
                            }
                            onChange={(assignedCategory) =>
                                _onCategoryChange(assignedCategory.value)
                            }
                        />
                    </div>,
                    filterQuery.data.filter.collection != undefined && <div key={3} className="mb-10">
                        <label className="form-label fw-semibold">Collection:</label>
                        <Select
                            name="collection"
                            className='react-select-styled react-select-solid react-select-sm'
                            classNamePrefix='react-select'
                            options={allOption.concat(filterQuery.data.filter.collection)}
                            placeholder='All'
                            defaultValue = {
                                filterQuery.data.filter.collection.filter(option => option.value == filterQuery.data.active.collection) || 0
                            }
                            onChange={(assignedCollection) =>
                                _onCollectionChange(assignedCollection.value)
                            }
                        />
                    </div>,
                    filterQuery.data.filter.brand != undefined
                    && [
                        <div key={1} className="separator border-gray-200 mb-10"></div>,
                        <div key={2} className="mb-10">
                            <label className="form-label fw-semibold">Brand:</label>
                            <Select
                                name="brand"
                                className='react-select-styled react-select-solid react-select-sm'
                                classNamePrefix='react-select'
                                options={allOption.concat(filterQuery.data.filter.brand)}
                                placeholder='All'
                                defaultValue = {
                                    filterQuery.data.filter.brand.filter(option => option.value == filterQuery.data.active.brand) || 0
                                }
                                onChange={(assignedBrand) =>
                                    _onBrandChange(assignedBrand.value)
                                }
                            />
                        </div>
                    ]
                ])
            }

        </div>
        <div className="card-footer py-4">
            <div className="d-flex justify-content-end">
                <button
                    type="reset"
                    className="btn btn-sm btn-light btn-active-light-primary me-2"
                    onClick={_onFilterReset}
                >
                    Reset
                </button>

                <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    onClick={_onFilterSubmit}
                >
                    Apply
                </button>
            </div>
        </div>
    </>
}